/**
 * The app-level export-ledger seam.
 *
 * Same shape, and the same reason, as `DashboardSavedViews`: a table cannot
 * build its own ledger (the client comes from the app, the identity from the
 * live session), so declaring it once here is what turns `<ExportMenu>` into a
 * recorded act everywhere instead of six surfaces each assembling a client.
 *
 * Under `<TenantProvider>` deliberately — the record is written at the caller's
 * tenancy, so a tenant switch must re-point the ledger with it.
 */
import type * as React from "react";
import { ExportLedgerProvider } from "@authe/export";
import { useExportLedgerSource } from "@/api/adapters";

export function DashboardExportLedger({
  children,
}: {
  children: React.ReactNode;
}): React.ReactElement {
  const ledger = useExportLedgerSource();
  return <ExportLedgerProvider ledger={ledger}>{children}</ExportLedgerProvider>;
}
